import {Injectable} from '@angular/core';
import {UxReviewCintCom} from '@app/components/publications/create-publication/_store/active-publication.reducers';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicationLinksService {

  baseUrl = environment.legacyBaseUrl;

  appCommunity = environment.appCommunityUrl;

  constructor() {
  }

  getUrlBase(lang, projectSlug): string {
    return `${this.baseUrl}/${lang}/app/csr/publicaccess/${projectSlug}`;
  }

  getPublicationPublicLink(
    payLoad: {
      pubUuid: string,
      lang: string,
      projectSlug: string, // Seems deprecated for v2....
      comId: number,
      isCint: boolean,
      testMode: boolean,
      directMode: boolean,
      utms: { key: string, value: string }[],
      forceLang: string,
      v2Link: boolean,
      askLang: boolean,
    }
  ): string {

    const params = [];

    // ?
    params.push(`com_ID=${encodeURIComponent(payLoad.comId)}`);

    // if (payLoad.testMode) {
    //  params.push(`test=${encodeURIComponent(payLoad.pubUuid)}`);
    // } else if (payLoad.directMode) {

    if (payLoad.isCint) {
      params.push(`cint=[ID]&yob=[YOB]&s=[S]`);
      params.push(`pubUuid=${encodeURIComponent(payLoad.pubUuid)}`);
    } else {
      if (payLoad.directMode) {
        params.push(`pubUuid=${encodeURIComponent(payLoad.pubUuid)}`);
      }
    }
    if (payLoad.testMode) {
      params.push(`debug=123`);
    }

    if (payLoad.utms.length > 0) {
      payLoad.utms.forEach((aUtm) => {
        params.push(`${aUtm.key}=${encodeURIComponent(aUtm.value)}`);
      });
    }

    if (payLoad?.forceLang) {
      params.push(`force_lang=${payLoad.forceLang}`);
    }

    if (payLoad?.askLang) {
      params.push(`ask_lang=1`);
    }

    // Pour les liens 'v2' - la langue se passe en get -- équivalent à forceLang, car AppCommunity est censé détecter la langue....
    if (payLoad.v2Link) {
      params.push(`lang=${payLoad.lang}`);
    }


    return `${payLoad.v2Link ? `${this.appCommunity}/publication/public` : this.getUrlBase(payLoad.lang, payLoad.projectSlug)}?${params.join('&')}`;

  }

  // getCommunityUrl(pubUuid: string, projectSlug, comId, lang, testMode = false): string {
  //   const url = `${this.getUrlBase(lang, projectSlug)}?com_ID=${comId}${testMode ? `&test=${pubUuid}` : ''}`;
  //   return url;
  // }
  //
  // getCintUrl(pubUuid: string, cintInfo: UxReviewCintCom, lang, testMode: boolean = false): string {
  //   return `${this.getUrlBase(lang, cintInfo.projectSlug)}?com_ID=${cintInfo.comId}&cint=[ID]&yob=[YOB]&pc=[PC]&s=[S]${testMode ? `&test=${pubUuid}` : ''}`;
  // }


}
